<template>
  <div style="width: 100%;">
    <PCNavbar class="hidden-xs-only none_992" />
    <MobileNavBar class="hidden-md-and-up" />
    <TitleComponent class="hidden-xs-only none_992" />
    <TitleComponentMobile class="hidden-md-and-up" />

    <ValueProposition class="hidden-xs-only none_992" />
    <ValuePropositionMobile class="hidden-md-and-up" />
    <ApplicationScenario class="hidden-xs-only none_992" />
    <ApplicationScenarioMobile class="hidden-md-and-up" />
    <UserCases class="hidden-xs-only none_992" />
    <UserCasesMobile class="hidden-md-and-up" />
    <CallMe class="hidden-xs-only none_992" />
    <MobileCallme class="hidden-md-and-up" />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import TitleComponent from '@/components/titleComponent/index'
import TitleComponentMobile from '@/components/titleComponentMobile/index'
// import IndustryList from '@/components/industryList/index'
// import IndustryDetails from '@/components/industryDetails/index'
import UserCases from '@/components/user_cases/index'
import UserCasesMobile from '@/components/user_cases_mobile/index'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/callMeMile.vue'
import ValueProposition from '@/components/valueProposition/index'
import ValuePropositionMobile from '@/components/valuePropositionMobile/index'
import ApplicationScenario from '@/components/applicationScenario/index'
import ApplicationScenarioMobile from '@/components/applicationScenarioMobile/index'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    TitleComponent,
    TitleComponentMobile,
    UserCases,
    ValueProposition,
    ValuePropositionMobile,
    ApplicationScenario,
    ApplicationScenarioMobile,
    CallMe,
    UserCasesMobile,
    MobileCallme,
  },
  data() {
    return {
      selectedIndustry: '', // 当前选中的行业
    };
  },
  methods: {
    updateSelectedIndustry(industry) {
      this.selectedIndustry = industry;
    },
  },
}
</script>

<style lang="scss" scoped>
.industry-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
